export const LoadingPage = () => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col justify-center items-center text-white">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
                    <p className="mt-4 text-lg">...אנא המתן</p>
       </div>
      );
}

export default LoadingPage